<template>
  <v-container>
    <h2>{{$t('dl.title')}}</h2>
    <v-row>
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title>{{$t('dl.official_title')}}<v-divider class="mx-2" vertical></v-divider><small class="text-caption grey--text lighten-2">Windows/Linux/macOS</small></v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="5">
                <h2 class="text-h6">Nyan Luncher</h2>
                <span class="text-caption">{{$t('dl.version')}}2.0.0-Alpha</span>
                <v-card-subtitle class="px-0 pt-0 font-weight-bold"><a>{{$t('dl.release')}}></a></v-card-subtitle>
                <v-card-text class="px-0">
                  {{$t('dl.official_new_note')}}
                </v-card-text>
              </v-col>
              <v-spacer></v-spacer>
              <!-- <v-divider vertical></v-divider> -->
              <v-col class="d-flex flex-column"  cols="6" md="3">
                <h3 class="font-weight-bold mb-2">NyanRT</h3>
                <i18n path="dl.official_new_rt" tag="span">
                  <v-icon place="iconList" size="24">list</v-icon>
                  <v-icon place="iconGames" size="18">games</v-icon>
                </i18n>
                <v-spacer></v-spacer>
                <v-card-actions class="mb-0 pa-0">
                  <v-btn depressed disabled color="primary">{{$t('dl.btn_stayTuned')}}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn depressed color="primary" to="/user/mygames">{{$t('dl.btn_online')}}</v-btn>
                </v-card-actions>
              </v-col>
              <!-- <v-divider vertical></v-divider> -->
              <v-col class="d-flex flex-column" cols="6" md="3">
                <h3 class="font-weight-bold mb-2">NyanUX</h3>
                <span>{{$t('dl.official_new_ux')}}</span>
                <v-spacer></v-spacer>
                <v-btn class="mb-0" depressed disabled color="primary" width="100%">{{$t('dl.btn_stayTuned')}}</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-subtitle class="pb-0">{{$t('dl.official_old_title')}}</v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="8" md="">
                <h2 class="text-h6">MAKjust Luncher</h2>
                <span class="text-caption">{{$t('dl.version')}}1.1.5</span>
              </v-col>
              <v-col cols="4" md="3">
                <v-btn class="mb-0" depressed color="primary" width="100%">{{$t('dl.btn_download')}}</v-btn>
              </v-col>
            </v-row>
            <a class="font-weight-bold">{{$t('dl.official_historyVer')}}></a>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>{{$t('dl.java_title')}}</v-card-title>
          <v-card-text>
            {{$t('dl.java_note')}}
          </v-card-text>
          <v-card-actions>
            <v-btn
              depressed
              color="primary"
              width="100%"
              href="https://www.java.com/zh-CN/download/"
              target="_blank"
              >{{$t('dl.btn_toDownload')}}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-tabs>
            <v-tab>{{$t('dl.luncher_title')}}</v-tab>
            <v-tab disabled>{{$t('dl.shadow_title')}}</v-tab>
            <v-tab disabled>{{$t('dl.mods_title')}}</v-tab>
          </v-tabs>
          <v-card-text>
            <span>*{{$t('dl.luncher_tip')}}</span>
            <v-row>
              <v-col
                cols="12"
                md="6"
                v-for="(luncher, i) in otherClients"
                :key="`_DOWNLAOD-OTHERCLIENTSLIST-${i}`"
              >
                <v-card outlined>
                  <!-- <v-card-title>
                    <v-icon large>inbox</v-icon><v-divider class="mx-2" vertical></v-divider>Windows
                  </v-card-title> -->
                  <v-card-title>
                    {{ luncher.name }}
                  </v-card-title>
                  <!-- <v-card-subtitle><a href="http://">发行页面></a></v-card-subtitle> -->
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-row>
                      <v-col cols="8">
                        <span>{{ luncher.explanation }}</span>
                      </v-col>
                      <v-col cols="4">
                        <template v-if="luncher.links">
                          <v-btn v-for="(link, i) in luncher.links" :key="`_DOWNLOAD-OPTHERCLIENTLIST-DLBTN-${i}`" depressed color="primary" width="100%" :href="link" target="_blank">{{$t('dl.btn_toDownload')}}</v-btn>
                        </template>
                        <v-btn v-else depressed disabled color="primary" width="100%">{{$t('dl.btn_noDownload')}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text class="pt-0 pb-2">
                    <small>*{{$t('dl.luncher_download_note')}}</small>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "DLPAGE",
  data() {
    return {
      otherClients: this.$store.state.OPTIONS._page_dl_launchers.other,
    };
  },
};
</script>